export { default as Contact } from './Contact';


// WEBPACK FOOTER //
// ./src/screens/Contact/index.js